import React, { useEffect }  from "react";
import ReportTable from "./components/ReportTable";
import SearchFilter from "components/search/SearchFilter";

import { connect } from "react-redux";
import { getReportList } from "../../../redux/report/reportState";

const Reports = ({doSearch, recordList}) => {
	
	useEffect(() => {
	    doSearch();
    }, [doSearch]);
    
    const searchHandler = (filters) => {
		doSearch(filters);
	}
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		<SearchFilter className="hidden"
      			searchHandler={searchHandler}
      		/>
      		
	      	<ReportTable tableData={recordList}/>
	      	
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
	recordList: state.report.reportList?.items,
  	requesting: state.report.reportList?.requesting,
  	error: state.report.reportList?.error,
  
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getReportList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Reports);